import type { JSX } from 'react';
import React from 'react';
import { useTranslation } from 'react-i18next';

import type { BlackbaudRaisersEdgeIntegration } from '@feathr/blackbox';
import type { IIntegrationUISettingsSection } from '@feathr/components';

import RaisersEdgeTabContent from '../RaisersEdgeTabContent';
import RaisersEdgeConnectionDetails from './RaisersEdgeConnectionDetails';
import RaisersEdgeUnsubscribeSettings from './RaisersEdgeUnsubscribeSettings';

interface IProps {
  integration: BlackbaudRaisersEdgeIntegration;
  /** The config's settings sections. */
  sections: readonly IIntegrationUISettingsSection[];
  /** Disconnects the integration. Rejects on failure, so the confirm modal stays open. */
  onDisconnect: () => Promise<void>;
  /** Disables every setting with this reason, e.g. while the page saves. */
  disabledReason?: string;
}

function RaisersEdgeSettingsTab({
  disabledReason,
  integration,
  onDisconnect,
  sections,
}: Readonly<IProps>): JSX.Element {
  const { t } = useTranslation();

  return (
    <RaisersEdgeTabContent
      inactiveLabel={t('Connect Blackbaud to see the connection details and manage unsubscribes.')}
      integration={integration}
    >
      <RaisersEdgeConnectionDetails
        disabledReason={disabledReason}
        integration={integration}
        onDisconnect={onDisconnect}
      />
      <RaisersEdgeUnsubscribeSettings
        disabledReason={disabledReason}
        integration={integration}
        sections={sections}
      />
    </RaisersEdgeTabContent>
  );
}

export default RaisersEdgeSettingsTab;
